import React, { useState } from 'react';
import { useCrudOperations } from '../../../components/Hooks/useCrudOperations';
import { API_URL } from '../../../utils/api';
import { invalidateGlobalCache } from '../../../hooks/useApiCache';

function RemoveSupplier({ supplier, setSuppliers, suppliers, buttonClassName, iconClassName, onSuccess }) {
  const [openDialog, setOpenDialog] = useState(false);
  const { removeItem } = useCrudOperations(`${API_URL}/suppliers`, setSuppliers, suppliers);

  const handleRemoveClick = (e) => {
    e.stopPropagation();
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await removeItem(supplier._id);
      setOpenDialog(false);
      
      invalidateGlobalCache([
        'dashboard_suppliers',
        'myassigned_suppliers',
        'myprojects_suppliers',
        'myprojects_favorites'
      ]);
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCloseDialog = (e) => {
    if (e) e.stopPropagation();
    setOpenDialog(false);
  };

  return (
    <>
      <button
        onClick={handleRemoveClick}
        className={buttonClassName}
      >
        <svg
          className={iconClassName}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      </button>

      {openDialog && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          onClick={handleCloseDialog}
        >
          <div 
            className="bg-white rounded-xl p-6 max-w-md w-full"
            onClick={e => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-2">Bekräfta borttagning</h3>
            <p className="text-gray-600 mb-6">
              Är du säker på att du vill ta bort leverantören "{supplier.companyName}"? 
              Denna åtgärd går inte att ångra.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleCloseDialog}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors duration-200"
              >
                Avbryt
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 bg-leadme-red text-white rounded-lg hover:bg-leadme-red-dark transition-colors duration-200"
              >
                Ta bort
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RemoveSupplier;

